import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles({
  root: {
    maxWidth: 345
  },
  media: {
    height: 140
  }
})

export default function MediaCard (props) {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      {props.disabled ? (
        <div style={{ position: 'absolute' }}>Under development on phase 2</div>
      ) : (
        <></>
      )}
      <CardActionArea
        onClick={props.clicked}
        disabled={props.disabled}
        style={props.disabled ? { opacity: '0.5' } : {}}
      >
        <CardMedia
          className={classes.media}
          image={props.image}
        />
        <CardContent>
          <Typography gutterBottom variant='h5' component='h2'>
            {props.cardName}
          </Typography>
          <Typography variant='body2' color='textSecondary' component='p'>
            {props.cardDescription}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>{props.actions}</CardActions>
    </Card>
  )
}
